import useOpenGive from '@/core/hooks/useOpenGive/useOpenGive';

export default useOpenGive;
